/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class People extends React.Component {
	render() {
		
		return (
            <div>
				{this.props.children}
            </div>
		)
	}
};
export default People;


// WEBPACK FOOTER //
// ./src/routes/people/index.js